import React, { useCallback, useContext } from 'react'
import { GradesStyles } from './Style'
import { Tabs } from 'components'
import { createClassHooks } from '../CreateClass'
import { SchoolContext } from './SchoolContext'
import { schoolHooks } from '.'
import { Button, CheckBox } from 'components/Form'
import TestTakers from './TestTakers'

const Grades = (props) => {
    const { grade } = props

    const { invalidTestTakers, gradeOpen, grades, affiliation, classIndexTab, setClassIndexTab, promoteSelection, setPromoteSelection, promoteSelectedGradeId, setPromoteSelectedGradeId, classStudentsCache } = useContext(SchoolContext)

    // צ'קבוקס לבחירת כיתה שלמה (להעלאת שנה)  
    const classDisabled = promoteSelectedGradeId && promoteSelectedGradeId != grade?.id
    const toggleClassSelection = useCallback((classId, checked) => {
        const next = { ...promoteSelection }
        const studentIds = classStudentsCache[classId] || []

        if (checked) {
            next[classId] = true
            studentIds.forEach(id => { next[id] = true })
        } else {
            delete next[classId]
            studentIds.forEach(id => { delete next[id] })
        }

        setPromoteSelection(next)
        setPromoteSelectedGradeId(Object.keys(next).length ? (promoteSelectedGradeId || grade?.id) : null)
    }, [promoteSelection, promoteSelectedGradeId, grade, classStudentsCache])

    const classes = grade?.classes?.map(cls => ({
        ...cls,
        label: (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <span onClick={e => e.stopPropagation()}>
                    <CheckBox
                        disabled={classDisabled}
                        input={{
                            value: !!promoteSelection[cls.id],
                            onChange: checked => toggleClassSelection(cls.id, checked)
                        }}
                    />
                </span>
                {cls.class_name}
            </div>
        )
    }))

    const createShortClass = createClassHooks.useCreateShortClass()
    const createClass = schoolHooks.useCreateClass()

    const changeTab = useCallback((index) => {
        setClassIndexTab(index)
    }, [])

    const addClass = useCallback(() => {
        createShortClass(true, {
            affiliation: affiliation.data?.id,
            grade: grade.id,
            action: createClass
        })
    }, [affiliation, grade])

    return (
        <GradesStyles>
            <div className='classes'>
                {classes &&
                    <Tabs
                        labelKey="class_name"
                        handleTab={changeTab}
                        tabs={classes}
                        defaultValue={classIndexTab}
                    />}
                <Button
                    label=" + הוספת כיתה "
                    action={addClass}
                    color="dark"
                    size="small"
                />
            </div>
            <div className='divider' />
            <TestTakers
                invalidTestTakers={invalidTestTakers}
                grade={gradeOpen}
                grades={grades}
                affiliation={affiliation}
                learningUnitKey={"school_class"}
                learningUnit={classes?.[classIndexTab]}
            />
        </GradesStyles>
    )
}
export default Grades